/**
 * Created by Josef Jurca on 8.3.2017.
 */

import {getInstance as getDataSources} from 'datasources';
import _ from 'lodash';

// Action types
const ActionTypes = {
        SET_LINEAR_CHANNELS: 'SET_LINEAR_CHANNELS',
        LINEAR_CHANNELS_SET_STATUS: 'LINEAR_CHANNELS_SET_STATUS',
        LINEAR_CHANNELS_SET_ERROR: 'LINEAR_CHANNELS_SET_ERROR'
    },

    // Status values
    LinearChannelStatuses = {
        INITIAL: 'initial',
        REQUEST_OPEN: 'request-open',
        REQUEST_FAILURE: 'request-failure',
        REQUEST_SUCCESS: 'request-success'
    };

/**
 * Creates and returns a set status action.
 *
 * @param {string} status - Linear channels status.
 * @returns {Object} Set status action.
 */
function setStatus (status = LinearChannelStatuses.INITIAL) {

    return {
        type: ActionTypes.LINEAR_CHANNELS_SET_STATUS,
        status
    };
}

/**
 * Creates and returns a set error action.
 *
 * @param {string} error - Error.
 * @returns {Object} Set error action.
 */
function setError (error = '') {

    return {
        type: ActionTypes.LINEAR_CHANNELS_SET_ERROR,
        error
    };
}

/**
 * Creates and returns a set linear channels action.
 *
 * @param {Array} linearChannels - Linear channels.
 * @returns {Object} Set linear channels action.
 */
function setLinearChannels (linearChannels) {
    return {
        type: ActionTypes.SET_LINEAR_CHANNELS,
        linearChannels
    };
}

/**
 * Creates and returns a fetch linear channels action.
 *
 * @returns {Function} Dispatch function.
 */
function fetchLinearChannels () {
    return (dispatch, getState) => {

        let dataSources = getDataSources(),
            linearChannelsAlreadyLoaded = _.get(getState(), ['linearChannels', 'status']) === LinearChannelStatuses.REQUEST_SUCCESS;

        if (linearChannelsAlreadyLoaded) {
            return;
        }

        dispatch(setStatus(LinearChannelStatuses.REQUEST_OPEN));

        dataSources.getConfig().then((config) => {
            return _.get(config, ['_presets', 'assetTypes', 'LINEAR']);
        })
        .then((linearTypeId) => {
            return dataSources.getLinearChannels(linearTypeId);
        })
        .then((linearChannels) => {
            dispatch(setLinearChannels(linearChannels));
            dispatch(setError(null));
            dispatch(setStatus(LinearChannelStatuses.REQUEST_SUCCESS));
        })
        .catch(reason => {
            let error = reason.error;

            error = typeof error === 'string'
                ? error
                : error && error.message;

            dispatch(setError(error));
            dispatch(setStatus(LinearChannelStatuses.REQUEST_FAILURE));
        });
    };
}

export {
    ActionTypes,
    LinearChannelStatuses,
    setStatus,
    setError,
    setLinearChannels,
    fetchLinearChannels
};


// WEBPACK FOOTER //
// ./src/js/store/actions/linearchannels.js